/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import {
  CourierUser,
  CourierUserFromJSON,
  CourierUserToJSON,
} from './CourierUser';
import { Invoice, InvoiceFromJSON, InvoiceToJSON } from './Invoice';
import {
  CourierCustomer,
  CourierCustomerFromJSON,
  CourierCustomerToJSON,
} from './CourierCustomer';
import {
  StorageSpot,
  StorageSpotFromJSON,
  StorageSpotToJSON,
} from './StorageSpot';
import {
  StoreLocation,
  StoreLocationFromJSON,
  StoreLocationToJSON,
} from './StoreLocation';
import {
  Courier,
  CourierFromJSON,
  CourierToJSON,
} from './Courier';
import {
  WarehouseInvoiceLineItem,
  WarehouseInvoiceLineItemFromJSON,
  WarehouseInvoiceLineItemToJSON,
} from './WarehouseInvoiceLineItem';

/**
 * Serialize a date field defensively. Package write payloads are built with
 * `as any` casts throughout the admin app, so TypeScript never proves these
 * are Dates. A plain `value.toISOString()` turns an ISO string into a
 * TypeError that kills the request in the browser before it is ever sent —
 * which is how a scan marker sent as a string broke every Scan-In status
 * update. Unknown values are passed through as strings for the server to
 * parse rather than throwing.
 */
function dateToJSON(value: any): string | undefined {
  if (value == null) return undefined;
  return value instanceof Date ? value.toISOString() : String(value);
}

/**
 *
 * @export
 * @interface CourierPackage
 */
export interface CourierPackage {
  /**
   *
   * @type {string}
   * @memberof CourierPackage
   */
  trackingNo?: string;
  /**
   * A second carrier tracking number on the same label (e.g. the USPS number
   * on a UPS SurePost label). Packages are matched on either number.
   * @type {string}
   * @memberof CourierPackage
   */
  alternateTrackingNo?: string | null;
  /**
   *
   * @type {string}
   * @memberof CourierPackage
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  value?: number;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  customsFee?: number;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  deliveryFee?: number;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  lateFee?: number;
  /**
   * Discount amount to apply to this package's invoice
   * @type {number}
   * @memberof CourierPackage
   */
  discount?: number;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  lastLateFeeAppliedDate?: Date;
  /**
   *
   * @type {boolean}
   * @memberof CourierPackage
   */
  isDeleted?: boolean;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  deletedOn?: Date;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  weight?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof CourierPackage
   */
  attachedFile?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CourierPackage
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof CourierPackage
   */
  merchant?: string;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  createdOn?: Date;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  createdBy?: number;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  lastUpdatedOn?: Date;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  warehouseDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  readyDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  deliveredDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  inTransitDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  preAlertDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  arrivedInJamaicaDate?: Date;
  /**
   *
   * @type {Date}
   * @memberof CourierPackage
   */
  onRouteToBranchDate?: Date;
  /**
   *
   * @type {string}
   * @memberof CourierPackage
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof CourierPackage
   */
  source?: string;
  /**
   *
   * @type {string}
   * @memberof CourierPackage
   */
  manifestNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof CourierPackage
   */
  businessPackage?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CourierPackage
   */
  isHalfPound?: boolean;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  ownerId?: number;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  courierId?: number;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  storeLocationId?: number;
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  manifestId?: number;
  manifest?: {
    id?: number;
    name?: string;
    awbReference?: string;
    scanStatus?: string;
  };
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  recipientId?: number;
  recipient?: CourierCustomer;
  recipientUserId?: number;
  recipientUser?: CourierUser;
  /**
   * CourierUser id of the staff member who last scanned this package via SmartScan/Scan-In.
   * @type {number}
   * @memberof CourierPackage
   */
  scannedBy?: number;
  /**
   * Server timestamp of the last SmartScan/Scan-In save (powers the daily scan counter).
   * @type {Date}
   * @memberof CourierPackage
   */
  scannedAt?: Date;
  /**
   * Whether a courier code (prefix + mailbox) was read off the label and resolved to a
   * known partner. `undefined` means the package was never Smart Scanned.
   * @type {boolean}
   * @memberof CourierPackage
   */
  hasCourierCode?: boolean;
  /**
   * The owner/recipient was not resolved with certainty and must be checked by a human.
   * Set server-side; cleared only via `courierPackageConfirmAssignment`.
   * @type {boolean}
   * @memberof CourierPackage
   */
  needsAssignmentReview?: boolean;
  /** How the owner was resolved: exact | probable | ambiguous | none | manual */
  assignmentConfidence?: string;
  /** Which Smart Scan strategy produced the owner: mailbox | name | cross-partner | manual */
  assignmentSource?: string;
  /** Comma-joined reason codes, e.g. "NO_COURIER_CODE,PARTIAL_NAME_MATCH" */
  assignmentReviewReason?: string;
  /** The courier code exactly as printed on the label, e.g. "ENV-1019" */
  labelCode?: string;
  /** CourierUser id of the staff member who confirmed the assignment */
  assignmentReviewedBy?: number;
  /** When the assignment was confirmed */
  assignmentReviewedAt?: Date;
  /** AI (Claude Vision) estimate of the contents' US retail value, in USD. Set by the hourly invoice-review sweep; never overwrites `value`. */
  estimatedValue?: number;
  /** Short item list behind estimatedValue */
  estimatedValueReason?: string;
  /** low | medium | high */
  estimatedValueConfidence?: string;
  /** When estimatedValue was produced */
  valueAssessedAt?: Date;
  /** SmartScanned package that likely needs a commercial invoice (AI estimate > $100 or weight > 10 lb) */
  needsInvoiceReview?: boolean;
  /** Comma-joined reason codes: high_value, heavy */
  invoiceReviewReasons?: string;
  /** CourierUser id of the staff member who dismissed the invoice-review flag */
  invoiceReviewDismissedBy?: number;
  /** When the invoice-review flag was dismissed */
  invoiceReviewDismissedAt?: Date;
  /**
   * Courier id of the sub-courier whose own delivery closed this package out.
   * Non-null means the current status came from the partner sync rather than
   * this courier's own staff. Written server-side only.
   */
  statusSyncedFromCourierId?: number;
  /** When the partner sync set the status */
  statusSyncedAt?: Date;
  /**
   * On a WAREHOUSE package: the status its sub-courier mirror last reported
   * (Ready / Out for Delivery / Delivered), stored verbatim. Recorded even
   * when the warehouse's own status is deliberately left alone — a row still
   * at "At Warehouse" whose sub-courier already delivered is the divergence
   * this field exists to surface. Unlike statusSyncedFromCourierId it is NOT
   * cleared when the warehouse's own status changes. Written server-side only.
   */
  subCourierStatus?: string;
  /** When the sub-courier last reported subCourierStatus */
  subCourierStatusAt?: Date;
  /** Courier id of the sub-courier that reported subCourierStatus */
  subCourierStatusCourierId?: number;

  owner?: CourierUser;
  createdByUser?: CourierUser;
  statusSyncedFromCourier?: Courier;
  subCourierStatusCourier?: Courier;
  subCourierUser?: CourierCustomer;
  invoice?: Invoice;
  serviceFee?: number;
  isSeaFreight?: boolean;
  length?: number;
  width?: number;
  height?: number;
  isBarrel?: boolean;
  isExpress?: boolean;
  isInvoiceUploaded?: boolean;
  isMislabeled?: boolean;
  isUnknown?: boolean;
  /** The name printed on the package label, useful for identifying unknown packages */
  nameOnPackage?: string;
  /** Admin notes for the package */
  packageNotes?: string;
  /** Count of pending claims (only present on unknown packages response) */
  pendingClaimCount?: number;
  /**
   * Harmonized System code for customs classification
   * @type {string}
   * @memberof CourierPackage
   */
  hsCode?: string;
  /**
   * Additional information for customs declarations
   * @type {object}
   * @memberof CourierPackage
   */
  customsInfo?: {
    freightValue?: number;
    freightCurrency?: string;
    insuranceValue?: number;
    insuranceCurrency?: string;
    transportValue?: number;
    transportCurrency?: string;
    pcIndicator?: string;
  };
  /**
   * Information for container shipments
   * @type {object}
   * @memberof CourierPackage
   */
  containerInfo?: {
    containerNumber?: string;
    sealNumber?: string;
    containerType?: string;
    emptyFull?: string;
    emptyWeight?: number;
  };
  /**
   *
   * @type {number}
   * @memberof CourierPackage
   */
  storageSpotId?: number;
  /**
   *
   * @type {StorageSpot}
   * @memberof CourierPackage
   */
  storageSpot?: StorageSpot;
  /**
   *
   * @type {StoreLocation}
   * @memberof CourierPackage
   */
  storeLocation?: StoreLocation;
  /**
   *
   * @type {Courier}
   * @memberof CourierPackage
   */
  courier?: Courier;
  /**
   * Warehouse-invoice line items that reference this package via packageId.
   * Populated when fetching with `include: 'warehouseInvoiceLineItems'`; each
   * item may carry a nested `invoice` so the admin Packages table can render
   * billing status in one round trip.
   * @type {Array<WarehouseInvoiceLineItem>}
   * @memberof CourierPackage
   */
  warehouseInvoiceLineItems?: Array<WarehouseInvoiceLineItem>;
}

/**
 * Check if a given object implements the CourierPackage interface.
 */
export function instanceOfCourierPackage(
  value: object
): value is CourierPackage {
  if (!('trackingNo' in value) || value['trackingNo'] === undefined)
    return false;
  return true;
}

export function CourierPackageFromJSON(json: any): CourierPackage {
  return CourierPackageFromJSONTyped(json, false);
}

export function CourierPackageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CourierPackage {
  if (json == null) {
    return json;
  }
  return {
    trackingNo: json['trackingNo'],
    alternateTrackingNo: json['alternateTrackingNo'] == null ? undefined : json['alternateTrackingNo'],
    description: json['description'] == null ? undefined : json['description'],
    value: json['value'] == null ? undefined : json['value'],
    customsFee: json['customsFee'] == null ? undefined : json['customsFee'],
    deliveryFee: json['deliveryFee'] == null ? undefined : json['deliveryFee'],
    lateFee: json['lateFee'] == null ? undefined : json['lateFee'],
    discount: json['discount'] == null ? undefined : json['discount'],
    lastLateFeeAppliedDate:
      json['lastLateFeeAppliedDate'] == null
        ? undefined
        : new Date(json['lastLateFeeAppliedDate']),
    isDeleted: json['isDeleted'] == null ? undefined : json['isDeleted'],
    deletedOn:
      json['deletedOn'] == null ? undefined : new Date(json['deletedOn']),
    weight: json['weight'] == null ? undefined : json['weight'],
    attachedFile:
      json['attachedFile'] == null ? undefined : json['attachedFile'],
    url: json['url'] == null ? undefined : json['url'],
    merchant: json['merchant'] == null ? undefined : json['merchant'],
    createdOn:
      json['createdOn'] == null ? undefined : new Date(json['createdOn']),
    createdBy: json['createdBy'] == null ? undefined : json['createdBy'],
    lastUpdatedOn:
      json['lastUpdatedOn'] == null
        ? undefined
        : new Date(json['lastUpdatedOn']),
    warehouseDate:
      json['warehouseDate'] == null
        ? undefined
        : new Date(json['warehouseDate']),
    readyDate:
      json['readyDate'] == null ? undefined : new Date(json['readyDate']),
    deliveredDate:
      json['deliveredDate'] == null
        ? undefined
        : new Date(json['deliveredDate']),
    inTransitDate:
      json['inTransitDate'] == null
        ? undefined
        : new Date(json['inTransitDate']),
    preAlertDate:
      json['preAlertDate'] == null ? undefined : new Date(json['preAlertDate']),
    arrivedInJamaicaDate:
      json['arrivedInJamaicaDate'] == null
        ? undefined
        : new Date(json['arrivedInJamaicaDate']),
    onRouteToBranchDate:
      json['onRouteToBranchDate'] == null
        ? undefined
        : new Date(json['onRouteToBranchDate']),
    status: json['status'] == null ? undefined : json['status'],
    source: json['source'] == null ? undefined : json['source'],
    manifestNumber:
      json['manifestNumber'] == null ? undefined : json['manifestNumber'],
    businessPackage:
      json['businessPackage'] == null ? undefined : json['businessPackage'],
    isHalfPound: json['isHalfPound'] == null ? undefined : json['isHalfPound'],
    id: json['id'] == null ? undefined : json['id'],
    ownerId: json['ownerId'] == null ? undefined : json['ownerId'],
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    storeLocationId:
      json['storeLocationId'] == null ? undefined : json['storeLocationId'],
    manifestId: json['manifestId'] == null ? undefined : json['manifestId'],
    manifest: json['manifest'] == null ? undefined : json['manifest'],
    recipientId: json['recipientId'] == null ? undefined : json['recipientId'],
    recipient:
      json['recipient'] == null
        ? undefined
        : CourierCustomerFromJSON(json['recipient']),
    recipientUserId:
      json['recipientUserId'] == null ? undefined : json['recipientUserId'],
    scannedBy: json['scannedBy'] == null ? undefined : json['scannedBy'],
    scannedAt:
      json['scannedAt'] == null ? undefined : new Date(json['scannedAt']),
    hasCourierCode:
      json['hasCourierCode'] == null ? undefined : json['hasCourierCode'],
    needsAssignmentReview:
      json['needsAssignmentReview'] == null
        ? undefined
        : json['needsAssignmentReview'],
    assignmentConfidence:
      json['assignmentConfidence'] == null
        ? undefined
        : json['assignmentConfidence'],
    assignmentSource:
      json['assignmentSource'] == null ? undefined : json['assignmentSource'],
    assignmentReviewReason:
      json['assignmentReviewReason'] == null
        ? undefined
        : json['assignmentReviewReason'],
    labelCode: json['labelCode'] == null ? undefined : json['labelCode'],
    assignmentReviewedBy:
      json['assignmentReviewedBy'] == null
        ? undefined
        : json['assignmentReviewedBy'],
    assignmentReviewedAt:
      json['assignmentReviewedAt'] == null
        ? undefined
        : new Date(json['assignmentReviewedAt']),
    estimatedValue:
      json['estimatedValue'] == null ? undefined : Number(json['estimatedValue']),
    estimatedValueReason:
      json['estimatedValueReason'] == null ? undefined : json['estimatedValueReason'],
    estimatedValueConfidence:
      json['estimatedValueConfidence'] == null ? undefined : json['estimatedValueConfidence'],
    valueAssessedAt:
      json['valueAssessedAt'] == null ? undefined : new Date(json['valueAssessedAt']),
    needsInvoiceReview:
      json['needsInvoiceReview'] == null ? undefined : json['needsInvoiceReview'],
    invoiceReviewReasons:
      json['invoiceReviewReasons'] == null ? undefined : json['invoiceReviewReasons'],
    invoiceReviewDismissedBy:
      json['invoiceReviewDismissedBy'] == null ? undefined : json['invoiceReviewDismissedBy'],
    invoiceReviewDismissedAt:
      json['invoiceReviewDismissedAt'] == null ? undefined : new Date(json['invoiceReviewDismissedAt']),
    statusSyncedFromCourierId:
      json['statusSyncedFromCourierId'] == null
        ? undefined
        : json['statusSyncedFromCourierId'],
    statusSyncedAt:
      json['statusSyncedAt'] == null
        ? undefined
        : new Date(json['statusSyncedAt']),
    statusSyncedFromCourier:
      json['statusSyncedFromCourier'] == null
        ? undefined
        : CourierFromJSON(json['statusSyncedFromCourier']),
    subCourierStatus:
      json['subCourierStatus'] == null ? undefined : json['subCourierStatus'],
    subCourierStatusAt:
      json['subCourierStatusAt'] == null
        ? undefined
        : new Date(json['subCourierStatusAt']),
    subCourierStatusCourierId:
      json['subCourierStatusCourierId'] == null
        ? undefined
        : json['subCourierStatusCourierId'],
    subCourierStatusCourier:
      json['subCourierStatusCourier'] == null
        ? undefined
        : CourierFromJSON(json['subCourierStatusCourier']),
    recipientUser:
      json['recipientUser'] == null
        ? undefined
        : CourierUserFromJSON(json['recipientUser']),
    owner:
      json['owner'] == null ? undefined : CourierUserFromJSON(json['owner']),
    createdByUser:
      json['createdByUser'] == null ? undefined : CourierUserFromJSON(json['createdByUser']),
    subCourierUser:
      json['subCourierUser'] == null
        ? undefined
        : CourierCustomerFromJSON(json['subCourierUser']),
    invoice:
      json['invoice'] == null ? undefined : InvoiceFromJSON(json['invoice']),
    serviceFee: json['serviceFee'] == null ? undefined : json['serviceFee'],
    isSeaFreight:
      json['isSeaFreight'] == null ? undefined : json['isSeaFreight'],
    length: json['length'] == null ? undefined : json['length'],
    width: json['width'] == null ? undefined : json['width'],
    height: json['height'] == null ? undefined : json['height'],
    isBarrel: json['isBarrel'] == null ? undefined : json['isBarrel'],
    isExpress: json['isExpress'] == null ? undefined : json['isExpress'],
    isInvoiceUploaded:
      json['isInvoiceUploaded'] == null ? undefined : json['isInvoiceUploaded'],
    isMislabeled: json['isMislabeled'] == null ? undefined : json['isMislabeled'],
    isUnknown: json['isUnknown'] == null ? undefined : json['isUnknown'],
    nameOnPackage: json['nameOnPackage'] == null ? undefined : json['nameOnPackage'],
    packageNotes: json['packageNotes'] == null ? undefined : json['packageNotes'],
    pendingClaimCount: json['pendingClaimCount'] == null ? undefined : json['pendingClaimCount'],
    hsCode: json['hsCode'] == null ? undefined : json['hsCode'],
    customsInfo: json['customsInfo'] == null ? undefined : json['customsInfo'],
    containerInfo: json['containerInfo'] == null ? undefined : json['containerInfo'],
    storageSpotId:
      json['storageSpotId'] == null ? undefined : json['storageSpotId'],
    storageSpot:
      json['storageSpot'] == null
        ? undefined
        : StorageSpotFromJSON(json['storageSpot']),
    storeLocation:
      json['storeLocation'] == null
        ? undefined
        : StoreLocationFromJSON(json['storeLocation']),
    courier:
      json['courier'] == null ? undefined : CourierFromJSON(json['courier']),
    warehouseInvoiceLineItems:
      json['warehouseInvoiceLineItems'] == null
        ? undefined
        : (json['warehouseInvoiceLineItems'] as Array<any>).map(WarehouseInvoiceLineItemFromJSON),
  };
}

export function CourierPackageToJSON(json: any): CourierPackage {
  return CourierPackageToJSONTyped(json, false);
}

export function CourierPackageToJSONTyped(
  value?: CourierPackage | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    trackingNo: value['trackingNo'],
    alternateTrackingNo: value['alternateTrackingNo'],
    description: value['description'],
    value: value['value'],
    customsFee: value['customsFee'],
    deliveryFee: value['deliveryFee'],
    lateFee: value['lateFee'],
    discount: value['discount'],
    weight: value['weight'],
    attachedFile: value['attachedFile'],
    url: value['url'],
    merchant: value['merchant'],
    createdOn: dateToJSON(value['createdOn']),
    createdBy: value['createdBy'],
    lastUpdatedOn: dateToJSON(value['lastUpdatedOn']),
    warehouseDate: dateToJSON(value['warehouseDate']),
    readyDate: dateToJSON(value['readyDate']),
    deliveredDate: dateToJSON(value['deliveredDate']),
    inTransitDate: dateToJSON(value['inTransitDate']),
    preAlertDate: dateToJSON(value['preAlertDate']),
    arrivedInJamaicaDate: dateToJSON(value['arrivedInJamaicaDate']),
    onRouteToBranchDate: dateToJSON(value['onRouteToBranchDate']),
    status: value['status'],
    source: value['source'],
    manifestNumber: value['manifestNumber'],
    businessPackage: value['businessPackage'],
    isHalfPound: value['isHalfPound'],
    id: value['id'],
    ownerId: value['ownerId'],
    courierId: value['courierId'],
    storeLocationId: value['storeLocationId'],
    manifestId: value['manifestId'],
    manifest: value['manifest'],
    recipientId: value['recipientId'],
    recipient:
      value['recipient'] == null
        ? undefined
        : CourierCustomerToJSON(value['recipient']),
    recipientUserId: value['recipientUserId'],
    scannedBy: value['scannedBy'],
    scannedAt: dateToJSON(value['scannedAt']),
    hasCourierCode: value['hasCourierCode'],
    needsAssignmentReview: value['needsAssignmentReview'],
    assignmentConfidence: value['assignmentConfidence'],
    assignmentSource: value['assignmentSource'],
    assignmentReviewReason: value['assignmentReviewReason'],
    labelCode: value['labelCode'],
    assignmentReviewedBy: value['assignmentReviewedBy'],
    assignmentReviewedAt: dateToJSON(value['assignmentReviewedAt']),
    estimatedValue: value['estimatedValue'],
    estimatedValueReason: value['estimatedValueReason'],
    estimatedValueConfidence: value['estimatedValueConfidence'],
    valueAssessedAt: dateToJSON(value['valueAssessedAt']),
    needsInvoiceReview: value['needsInvoiceReview'],
    invoiceReviewReasons: value['invoiceReviewReasons'],
    invoiceReviewDismissedBy: value['invoiceReviewDismissedBy'],
    invoiceReviewDismissedAt: dateToJSON(value['invoiceReviewDismissedAt']),
    statusSyncedFromCourierId: value['statusSyncedFromCourierId'],
    statusSyncedAt: dateToJSON(value['statusSyncedAt']),
    statusSyncedFromCourier:
      value['statusSyncedFromCourier'] == null
        ? undefined
        : CourierToJSON(value['statusSyncedFromCourier']),
    subCourierStatus: value['subCourierStatus'],
    subCourierStatusAt: dateToJSON(value['subCourierStatusAt']),
    subCourierStatusCourierId: value['subCourierStatusCourierId'],
    subCourierStatusCourier:
      value['subCourierStatusCourier'] == null
        ? undefined
        : CourierToJSON(value['subCourierStatusCourier']),
    recipientUser:
      value['recipientUser'] == null
        ? undefined
        : CourierUserToJSON(value['recipientUser']),
    owner:
      value['owner'] == null ? undefined : CourierUserToJSON(value['owner']),
    createdByUser:
      value['createdByUser'] == null ? undefined : CourierUserToJSON(value['createdByUser']),
    subCourierUser: value['subCourierUser'],
    invoice:
      value['invoice'] == null ? undefined : InvoiceToJSON(value['invoice']),
    serviceFee: value['serviceFee'],
    isSeaFreight: value['isSeaFreight'],
    length: value['length'],
    width: value['width'],
    height: value['height'],
    isBarrel: value['isBarrel'],
    isExpress: value['isExpress'],
    isInvoiceUploaded: value['isInvoiceUploaded'],
    isMislabeled: value['isMislabeled'],
    isUnknown: value['isUnknown'],
    nameOnPackage: value['nameOnPackage'],
    packageNotes: value['packageNotes'],
    lastLateFeeAppliedDate: dateToJSON(value['lastLateFeeAppliedDate']),
    isDeleted: value['isDeleted'],
    deletedOn: dateToJSON(value['deletedOn']),
    hsCode: value['hsCode'],
    customsInfo: value['customsInfo'],
    containerInfo: value['containerInfo'],
    storageSpotId: value['storageSpotId'],
    storageSpot:
      value['storageSpot'] == null
        ? undefined
        : StorageSpotToJSON(value['storageSpot']),
    storeLocation:
      value['storeLocation'] == null
        ? undefined
        : StoreLocationToJSON(value['storeLocation']),
    courier:
      value['courier'] == null ? undefined : CourierToJSON(value['courier']),
    warehouseInvoiceLineItems:
      value['warehouseInvoiceLineItems'] == null
        ? undefined
        : value['warehouseInvoiceLineItems'].map(WarehouseInvoiceLineItemToJSON),
  };
}

export interface WarehousePackage {
  name?: string;
  manifestNumber?: string;
  trackingNo?: string;
  description?: string;
  status?: string;
  weight?: number;
  date?: string;
  source?: string;
}
